export default __webpack_public_path__ + "static/media/Formato-Presupuesto-Inivtacion-Museos-2025.0837bd87.xlsx";